// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    hmr: false,
    gqlUrl: 'https://gqldev.spekwo.com/graphql',
    website: 'http://dev.spekwo.com/',
    displayWebsite: 'dev.spekwo.com',
    email: 'hello@spekwo.com',
    apiHost: 'https://dev.api.spekwo.com/',
    apiHostDisplay: 'dev.api.spekwo.com',
    customerUrl: 'https://dev.client.spekwo.com/',
    displayCusUrl: 'dev.client.spekwo.com',
    wpCouponSite: 'https://dev.spekwo.com/wp-admin/edit.php?post_type=shop_coupon',
    picStories: 'https://dev.api.spekwo.com/PictureStories/',
    ownerRoleId: '8dab2f2a-2866-4527-9b3d-d2237d8d24c7',
    executiveRoleId: "fe66b505-c5dd-46a4-94ed-acb1fabbfaab",
    juniorQuoterRoleId: "07c13539-0f8e-4cee-b1d8-100de0b3cdc2",
    seniorQuoterRoleId: "a1fc4d70-28a9-4e43-ba5f-4429886f5769",
    onBoarderRoleId: "8dab2f2a-2866-4527-9b3d-d2237d8d24c8", 
    apiHostDev: 'https://dev.api.spekwo.com/',
};



// WEBPACK FOOTER //
// /vercel/path0/src/environments/environment.ts